$(document).ready(function(){
 var chosen_product = {
  id: null,
  title: ""
 };
 var product = {
  id: null,
  title: "",
  description: "",
  image: ""
 }

 var productsCount = $("#corporate-gift-products").data("products-count");

 if(productsCount == 1){ //If it's just a single product, pre-select it already
  product["id"] = $(".image-product-button").data("product-id");
  product["title"] = $(".image-product-button").data("product-title");
  updateChosenProduct(product);
 }

 var host = "http://api.foxblossom.com/";
 $('#custom-portal-form').submit(function(event){
  if((chosen_product["id"] == null && chosen_product["title"] =="") && $("#custom-portal-collection").data("available") == true){
   alert("Please choose your gift");
  }
  else{
   $('#custom-portal-form-submit').prop('disabled', true);
   $('#custom-portal-form-submit').val("Processing...");

   var formData = updateFormData();

   $.ajax({
    type: "POST",
    url: host + "v1/corporategifts/data",
    data: formData,
    dataType: "json",
    encode: true,
   }).done(function (data) {
    alert(data.message);
    console.log(data);
    clearFormData();
    $('#custom-portal-form-submit').prop('disabled', false);
    $('#custom-portal-form-submit').val("Submit");
   });

  }



  event.preventDefault();
 });

 function updateFormData(){
  var formData = {
   first_name: $("#custom-portal-form-first-name").val(),
   last_name: $("#custom-portal-form-last-name").val(),
   address_line_1: $("#custom-portal-form-address-line-1").val(),
   address_line_2: $("#custom-portal-form-address-line-2").val(),
   city: $("#custom-portal-form-city").val(),
   state: $("#custom-portal-form-state").val(),
   zip_code: $("#custom-portal-form-zip-code").val(),
   sender_email: $("#custom-portal-form-sender-email").val(),
   recipient_email: $("#custom-portal-form-recipient-email").val(),
   company_name: $("#custom-portal-form-company-name").data("name"),
   chosen_product: chosen_product
  }
  if($("#custom-portal-form-message") != null){
   formData['message'] = $("#custom-portal-form-message").val();
  }
  if($("#custom-portal-form-shirt-size") != null){
   formData['shirt_size'] = $("#custom-portal-form-shirt-size").val();
  }

  return formData;

 }

 function clearFormData(){
  $("#custom-portal-form-first-name").val("");
  $("#custom-portal-form-last-name").val("");
  $("#custom-portal-form-address-line-1").val("");
  $("#custom-portal-form-address-line-2").val("");
  $("#custom-portal-form-city").val("");
  $("#custom-portal-form-state").val("");
  $("#custom-portal-form-zip-code").val("");
  $("#custom-portal-form-sender-email").val("");
  $("#custom-portal-form-recipient-email").val("");
  $("#custom-portal-form-company-name").data("name","");
  chosen_product["id"] = null;
  chosen_product["title"] = "";
  if($("#custom-portal-form-message") != null){
   $("#custom-portal-form-message").val("");
  }
 }

 $(".custom-portal-info-button").click(function(){
  //alert($(this).data("product-id") + ":" + $(this).data("product-title"));

  product["id"] = $(this).data("product-id");
  product["title"] = $(this).data("product-title");
  product["description"] = $(this).data("product-description");
  product["image"] = $(this).data("product-image")

  displayProductModal(product);

 });

 $(".image-product-button").click(function(){
   product["id"] = $(this).data("product-id");
   product["title"] = $(this).data("product-title");
   updateChosenProduct(product);
 });
 $(".close-btn").click(function(){
   $(".product-modal").hide();
 });


 // Modal functions

 $(".modal-product-button").click(function(){
  updateChosenProduct(product);
 });
 $(".close-btn").click(function(){
  $(".product-modal").hide();
 });

 function displayProductModal(product_info){
  $("#modal-product-title").html(product_info["title"]);
  $("#modal-product-description").html(product_info["description"]);
  $("#modal-product-image").attr('src', product_info["image"]);
  $(".product-modal").show();
 }

 function updateChosenProduct(product_info){
  $(".custom-portal-product").removeClass("custom-portal-product-chosen");
  //Add class to chosen Product
  $(".custom-portal-product-"+product_info["id"]).addClass("custom-portal-product-chosen");
  chosen_product["id"] = product_info["id"];
  chosen_product["title"] = product_info["title"];
  $(".product-modal").hide();
 }
  
})

// ===============================
